<template>
  <div :class="{'flex-wrap table-filter-item': label}">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      v-model="valueBackup"
      :clearable="clearable"
      :filterable="filterable"
      :multiple="multiple"
      :placeholder="placeholder"
      :size="size"
      @change="handleChange"
    >
      <el-option
        v-for="item in list"
        :key="item.value"
        :label="item.name"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
import { voucherIssueTypes } from '@/enums/voucherIssueTypes';

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    clearable: Boolean,
    filterable: Boolean,
    multiple: Boolean,
    label: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
    placeholder: {
      type: String,
      default: '请选择发放方式',
    },
  },
  data: () => ({
    valueBackup: 0,
    list: voucherIssueTypes,
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== this.valueBackup) this.valueBackup = value;
      }
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
      }
    },
  },
  methods: {
    handleChange(valueBackup) {
      this.$emit('change', valueBackup);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      this.valueBackup = this.value;
    }
  },
};
</script>
